export const getSearchList = (state: any) => state?.search?.searchList;
export const getSearchLoader = (state: any) => state?.search?.loading;
export const getBlogList = (state: any) => state?.search?.blogList;
export const getResourceList = (state: any) => state?.search?.resourceList;
export const getToolBoxList = (state: any) => state?.search?.toolBoxList;
export const getFormList = (state: any) => state?.search?.formList;
export const getSearchValue = (state: any) => state?.search?.searchValue;
